module.exports = __webpack_public_path__ + "img/dafault-dashboard.675e88dd.jpg";